<template>
  <div class="faq-area">
    <div class="container mw-1356">
      <div class="row align-items-center">
        <div
          class="col-lg-6"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="100"
        >
          <div class="faq-content">
            <span class="top-title">الأسئلة الشائعة</span>
            <h2>أجد إجابات لكل ما تريد معرفته</h2>
          </div>

          <div class="accordion style-two">
            <div
              class="accordion-item"
              v-for="(item, index) in accordionItems"
              :key="index"
              :class="{ active: activeIndex === index }"
            >
              <h2 class="accordion-header">
                <button
                  class="accordion-button pt-0"
                  type="button"
                  :aria-expanded="activeIndex === index ? 'true' : 'false'"
                  @click="toggleAccordion(index)"
                >
                  {{ item.question }}
                </button>
              </h2>
              <div
                class="accordion-collapse collapse show"
                v-show="activeIndex === index"
              >
                <div class="accordion-body">
                  <p>{{ item.answer }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="col-lg-6"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="200"
        >
          <div class="faq-img">
            <img src="@/assets/images/faq-2.png" alt="faq" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  // اسم متعدد الكلمات لتجنب خطأ ESLint
  name: "ServiceFaq",
  setup() {
    const activeIndex = ref<number>(0);

    const accordionItems = [
      {
        question: "ما هي الأجهزة التي تدعمها الخدمة؟",
        answer: "نحن ندعم جميع أجهزة أندرويد، شاشات سمارت (سامسونج و LG)، أجهزة Fire TV Stick، Apple TV، بالإضافة إلى أجهزة الكمبيوتر والهواتف الذكية.",
      },
      {
        question: "كيف أحصل على الدعم الفني؟",
        answer: "يمكنك التواصل معنا عبر الواتساب أو البريد الإلكتروني الموضح في الموقع في أي وقت، فريق الدعم لدينا جاهز لمساعدتك 24/7 في ضبط الإعدادات.",
      },
      {
        question: "كم يستغرق تفعيل الاشتراك؟",
        answer: "يتم إرسال بيانات اشتراكك فوراً بعد تأكيد عملية الدفع، وعادة ما تصلك في أقل من 15 دقيقة على بريدك الإلكتروني أو الواتساب.",
      },
      {
        question: "ما هي سياسة الاسترجاع؟",
        answer: "نقدم ضماناً لاستقرار الخدمة. إذا واجهت مشكلة تقنية لا يمكن حلها، يمكنك طلب استرداد المبلغ خلال أول 48 ساعة من الاشتراك.",
      },
      {
        question: "هل يمكنني تشغيل الاشتراك على أكثر من جهاز؟",
        answer: "باقاتنا مصممة لتشغيل جهاز واحد في نفس الوقت لضمان أفضل جودة، ولكن يمكنك نقل الاشتراك بين أجهزتك بكل سهولة.",
      },
    ];

    const toggleAccordion = (index: number) => {
      activeIndex.value = activeIndex.value === index ? -1 : index;
    };

    return {
      activeIndex,
      toggleAccordion,
      accordionItems,
    };
  },
});
</script>